// extracted by css-extract-rspack-plugin
export default {"container":"MessageContainer-styles-container-b11de398","innerContainer":"MessageContainer-styles-innerContainer-ab637162"};